import store from "../store";

/**
 * Don't go anywhere until determining if a user is logged in or not
 *
 * Needed so the route guards trigger correctly on initial page load
 */
export function firstTimeGuard(to, from, next) {
    if(store.state.firstAttempt) {
        (async () => {
            const getVersionPromise = store.dispatch('getVersion');
            const getUserPromise = store.dispatch('user/getUser');
            await getUserPromise;
            await getVersionPromise;
            store.commit('setAttempted');
            next();
        })();
        return;
    }
    next();
}

/**
 * A guard to make sure the user has the appropriate permissions to access a page
 *
 * WARNING:  Always secure the API, and never rely on this for anything other than UX.
 */
export function permissionsGuard(to, from, next) {
    if (!to.meta) {
        next();
        return;
    }

    switch (to.meta.permission) {
        case 'user':  //The user is logged in
            if (!store.getters['user/isLoggedIn']) {
                let nextQuery = to.path;
                next({name: 'home', query: {'next': nextQuery}});
                return;
            }
            break;
        case 'staff':  //The user is a member of HEAT
            if (!store.state.user.isStaff) {
                next({name: 'not-found'});
                return;
            }
            break;
    }
    next();
}
